<template lang="pug">
  .products
    v-dialog(
      v-model="removeDialog"
      persistent
      width="400px"
    )
      v-card
        v-card-title
          span.title.mx-auto {{$vuetify.lang.t('$vuetify.pages.Products.remove.title')}}
        v-card-text.pb-1.text-center
          span {{$vuetify.lang.t('$vuetify.pages.Products.remove.question')}}
        v-card-actions.d-flex.justify-center
          v-btn(@click="removeDialog = false" text) {{$vuetify.lang.t('$vuetify.buttons.cancel')}}
          v-btn.white--text(@click="remove" color="red") {{$vuetify.lang.t('$vuetify.buttons.remove')}}
    v-container.v-card.elevation-5.pa-4.mb-5
      v-card-text.d-flex.justify-center
        span.headline {{ $vuetify.lang.t('$vuetify.filters') }}
      v-card-text.px-0
        v-row.d-flex.justify-center
          v-col.py-0(cols="12" sm="4")
            v-text-field(
              :label="$vuetify.lang.t('$vuetify.pages.Brands.filters.query')"
              :value="filters.query"
              @change="e => filters.query = e"
              clearable
              hide-details
              outlined
            )
          v-col.py-0(cols="12" sm="4")
            v-select(
              :disabled="!!userBrandId"
              :label="$vuetify.lang.t(`$vuetify.pages.Users.table.brandId`)"
              :items="brands"
              v-model="filters.brandId"
              item-text="title"
              item-value="id"
              hide-details
              clearable
              outlined
            )
          v-col.py-0(cols="12" sm="4")
            v-select(
              :disabled="!!userEstablishmentId || !filters.brandId"
              :label="$vuetify.lang.t(`$vuetify.pages.Users.table.establishmentId`)"
              :items="establishments.filter(i => +i.brandId === +filters.brandId)"
              v-model="filters.establishmentId"
              :item-text="localizeField('name', $vuetify.lang.current)"
              item-value="id"
              hide-details
              clearable
              outlined
            )
        .options.d-flex.justify-end.align-center.mt-4
          v-switch.removed-toggle(
            :label="$vuetify.lang.t('$vuetify.pages.Brands.filters.removed')"
            @change="onTypeChange($event)"
            color="secondary"
          )

          v-btn.ml-3(
            @click="loadItems()"
            color="secondary"
          ) {{$vuetify.lang.t('$vuetify.buttons.search')}}
    .table-wrapper
      v-data-table.elevation-5.data-table(
        :headers="headers"
        :items="items"
        :items-per-page="200"
        :mobile-breakpoint="300"
        hide-default-footer
      )
        template(v-slot:header.price="{ header }")
          v-tooltip(top :nudge-top="25" )
            template(v-slot:activator='{ on, attrs }')
              span.d-inline-flex.align-center(v-on="on" style="cursor: help") {{header.text}}
                span.ml-1(style="color: #ccc; font-size: 10px") (?)
            span {{$vuetify.lang.t('$vuetify.pages.Products.dblClickToEdit')}}
        template(v-slot:item.name="{ item }")
          span {{ item.name }}
        template(v-slot:item.weight="{ item }")
          span {{ item.weight }} {{ $vuetify.lang.t('$vuetify.pages.Products.quantityTypes.' + item.quantityType) }}
        template(v-slot:item.price="{ item }")
          v-text-field.my-2(
            :label="$vuetify.lang.t('$vuetify.pages.Products.table.price')"
            v-model="editingPrice"
            v-if="!!item.isEditingPrice"
            @blur="saveNewPrice()"
            hide-details
            outlined
            autofocus
          )
          span(style="cursor: context-menu" v-else @dblclick="startPriceEditing(item)") {{ item.price }}{{$vuetify.lang.t('$vuetify.hrn')}}
        template(v-slot:item.establishmentPrice="{ item }")
          span(v-if="item.establishment") {{ +(item.price * (1 - +item.establishment.commission)).toFixed(2) }}{{$vuetify.lang.t('$vuetify.hrn')}}
        template(v-slot:item.clientPrice="{ item }")
          span(:class="{redText: (item.establishment.margin !== '0' || item.section.margin !== '0')}" v-if="item.establishment && item.section") {{ +(item.price * (1 + (+item.section.margin || +item.establishment.margin))).toFixed(2) }}{{$vuetify.lang.t('$vuetify.hrn')}}
        template(v-slot:item.shortDescription:uk="{ item }")
          span {{ (item['shortDescription:uk'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.shortDescription:ru="{ item }")
          span {{ (item['shortDescription:ru'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.shortDescription:en="{ item }")
          span {{ (item['shortDescription:en'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.detailedDescription:uk="{ item }")
          span {{ (item['detailedDescription:uk'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.detailedDescription:ru="{ item }")
          span {{ (item['detailedDescription:ru'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.detailedDescription:en="{ item }")
          span {{ (item['detailedDescription:en'] || '').replace(/(.{50})..+/, "$1…") }}
        template(v-slot:item.section="{ item }")
          span {{ item.section && item.section[localizeField('name', $vuetify.lang.current)] }}
        template(v-slot:item.status="{ item }")
          span {{ $vuetify.lang.t(`$vuetify.pages.Products.statuses.${item.status}`) }}
        template(v-slot:item.published="{ item }")
          div(class="d-flex justify-center align-center")
            v-checkbox(v-model="item.status === 'publish'" :disabled="!['publish', 'not-available'].includes(item.status)" @change="toggleAvailability({productId: item.id, currentStatus: item.status})" color="dark darken-1" hide-details class="ma-0")
        template(v-slot:item.isByWeight="{ item }")
          div(class="d-flex justify-center align-center")
            v-checkbox(v-model="item.isByWeight === true" disabled color="dark darken-1" hide-details class="ma-0")
        template(v-slot:item.brand="{ item }")
          span {{ item.brandId | brand }}
        template(v-slot:item.establishment="{ item }")
          span {{ item.establishment && item.establishment[localizeField('name', $vuetify.lang.current)] }}
        template(v-slot:item.establishmentAddress="{ item }")
          span {{ (item.establishmentAddress ? item.establishmentAddress.place : {})| place }}
        template(v-slot:item.createdAt="{ item }")
          span.no-wrap {{ item.createdAt | timeAndDate }}
        template(v-slot:item.updatedAt="{ item }")
          span.no-wrap {{item.updatedAt | timeAndDate }}
        template(v-slot:item.actions="{ item }")
          .default-actions.no-wrap(v-if="!isRemoved")
            v-btn(:to="`/products/editor/${item.id}`" icon)
              v-icon edit
            v-btn(@click="openRemoveDialog(item.id)" color="red" icon)
              v-icon delete
          .restore-actions(v-else)
            v-btn(
              @click="restore(item.id)"
              :title="$vuetify.lang.t('$vuetify.buttons.restore')"
              icon
            )
              v-icon restore
      v-pagination(
        v-if="pagination.totalPages > 1"
        :value="pagination.page"
        :length="pagination.totalPages"
        :disabled="requestProcessing"
        @input="loadItems($event)"
        :total-visible="8"
        color="black"
      )
    v-btn.mx-2.add-btn(
      v-if="canAddProduct"
      to="/products/editor"
      fab dark
    )
      v-icon(dark) mdi-plus
</template>

<style scoped lang="sass">
.redText
  color: #9b001d

::v-deep(.ma-0 .v-input--selection-controls__input)
  margin: 0 !important
</style>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';
import request from '@/utils/request';
import {VContainer} from "vuetify/lib/components";
import {localizeField, multilingualFieldKeys} from "@/helpers/locales";

export default {
  name: 'ProductsList',
  components: {
    'v-container': VContainer
  },
  data: () => ({
    filters: {
      query: null,
      brandId: null,
      establishmentId: null,
      type: 'active'
    },
    editingPrice: null,
    requestProcessing: false,
    removeDialog: false,
    idToRemove: null
  }),
  computed: {
    ...mapGetters(['roleName', 'userBrandId', 'userEstablishmentId']),
    ...mapState({
      items: state => state.deliveryProducts.items,
      pagination: state => state.deliveryProducts.pagination,
      savedFilters: state => state.deliveryProducts.filters,
      brands: state => state.data.brands,
      establishments: state => state.data.establishments
    }),
    headers() {
      const titles = this.getTitlesByRole();
      if (['admin', 'admin-delivery', 'admin-establishment'].includes(this.roleName)) {
        titles.push('actions');
      }
      return titles.map(it => ({
        text: this.$vuetify.lang.t(`$vuetify.pages.Products.table.${it}`),
        value: it,
        sortable: false,
        align: 'center'
      }));
    },
    isRemoved() {
      return this.filters.type === 'removed';
    },
    canAddProduct() {
      const availableRoles = ['admin', 'admin-delivery', 'admin-establishment'];
      return availableRoles.includes(this.roleName);
    }
  },
  watch: {
    'filters.brandId'(currentValue, prevValue) {
      if (prevValue && currentValue !== prevValue) {
        this.filters.establishmentId = null;
      }
    },
    filters: {
      handler() {
        this.$store.commit('deliveryProducts/UPDATE_FILTERS', this.filters);
      },
      deep: true
    }
  },
  setup() {
    return {
      localizeField
    };
  },
  beforeDestroy() {
    // this.resetFilters();
    // this.$store.commit('deliveryProducts/UPDATE_FILTERS', this.filters);
  },
  async created() {
    await this.loadBrands();
    await this.loadEstablishments();

    if ((this.userBrandId && !this.savedFilters.brandId) || (this.userEstablishmentId && !this.savedFilters.establishmentId)) {
      if (this.userBrandId) {
        this.filters.brandId = this.userBrandId;
      }
      if (this.userEstablishmentId) {
        this.filters.establishmentId = this.userEstablishmentId;
      }

      this.$store.commit('deliveryProducts/UPDATE_FILTERS', this.filters);
    } else {
      this.filters = this.savedFilters;
    }

    // this.loadItems(this.pagination.page);
  },
  methods: {
    ...mapActions({
      loadBrands: 'data/getBrands',
      loadEstablishments: 'data/getEstablishments',
      getItems: 'deliveryProducts/getItems'
    }),
    startPriceEditing(item) {
      this.editingPrice = item.price;

      this.$store.dispatch('deliveryProducts/startPriceEditing', item.id);
    },
    resetFilters() {
      this.filters = {
        query: null,
        brandId: null,
        establishmentId: null,
        type: 'active'
      };
    },
    saveNewPrice() {
      this.$store.dispatch('deliveryProducts/saveNewPrice', this.editingPrice).then(() =>
          this.editingPrice = null
      );
    },
    toggleAvailability({productId, currentStatus}) {
      this.$store.dispatch('deliveryProducts/toggleAvailability', {
        productId,
        newStatus: currentStatus === 'publish' ? 'not-available' : 'publish'
      });
    },
    onTypeChange(value) {
      const type = value ? 'removed' : 'active';
      this.$set(this.filters, 'type', type);
    },
    loadItems(page = 1) {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.getItems({page}).then(() => {
        this.$nextTick(() => this.requestProcessing = false);
      });
    },
    onPageChange(page) {
      if (page !== this.pagination.page) {
        this.loadItems(page);
      }
    },
    openRemoveDialog(idToRemove) {
      this.removeDialog = true;
      this.idToRemove = idToRemove;
    },
    getTitlesByRole() {
      switch (this.roleName) {
        case 'manager-establishment-ext':
          return [
            ...multilingualFieldKeys(['name']), 'weight', 'published', 'establishmentPrice',
            ...multilingualFieldKeys(['shortDescription']), ...multilingualFieldKeys(['detailedDescription']), 'section', 'status', 'isByWeight',
            'brand', 'establishment', 'establishmentAddress'
          ];

        case 'admin-establishment':
          return [
            ...multilingualFieldKeys(['name']), 'weight', 'published', 'price', 'establishmentPrice',
            ...multilingualFieldKeys(['shortDescription']), ...multilingualFieldKeys(['detailedDescription']), 'section', 'status', 'isByWeight',
            'brand', 'establishment', 'establishmentAddress'
          ];

        default:
          return [
            ...multilingualFieldKeys(['name']), 'weight', 'published', 'price', 'establishmentPrice', 'clientPrice',
            ...multilingualFieldKeys(['shortDescription']), ...multilingualFieldKeys(['detailedDescription']), 'section', 'status', 'isByWeight',
            'brand', 'establishment', 'establishmentAddress'
          ];
      }
    },
    async remove() {
      if (this.requestProcessing) {
        return;
      }

      this.requestProcessing = true;
      return request({
        method: 'delete',
        url: `/delivery/product/${this.idToRemove}`
      }).then(res => {
        if (res.status === 200) {
          this.idToRemove = null;
          this.removeDialog = false;
          this.requestProcessing = false;
          this.loadItems();
        }
      }).catch(error => this.errorHandler(error));
    },
    restore(id) {
      return request({
        method: 'put',
        url: `/delivery/product-restore/${id}`
      }).then(res => {
        if (res.status === 200) {
          this.loadItems();
        }
      }).catch(error => this.errorHandler(error));
    },
    errorHandler(error) {
      const message = error.response && error.response.data && error.response.data.error;

      if (message) {
        this.$store.dispatch('alert/addMessage', {
          message: `deliveryProducts.${message}`
        });
      }
    }
  }
};
</script>
